export const statusConfig = Object.freeze({
  init: -1, // show start button
  submitted: 0, // show pending button
  pending: 1, // show resubmit button
  completed: 2, // show complete button
  rejected: 3, // show resubmit button
  reaudit: 4, // show pending button
})
